import { AplicacionDetalleResponse } from "../response/AplicacionDetalleResponse";

/** Detalle (producto + dosis) de una aplicación a guardar. La lista de detalles
 *  se reemplaza completa en cada guardado. */
export type AplicacionDetalleRequest = {
  /** Producto aplicado (del catálogo de productos). */
  productoId: string;
  /** Descripción/nombre del producto. Se envía a la API (aceptado); si en el
   *  futuro debe ser UI-only, ver el patrón `toJSON` en CLAUDE.md. */
  productoDescripcion: string;
  /** Dosis aplicada: por hectárea en dron, por recipiente en los manuales. */
  dosis: number;
  /** Id del detalle a actualizar; null = nuevo. */
  id: string | null;
};

export const fx_createAplicacionDetalle = (
  response: AplicacionDetalleResponse,
): AplicacionDetalleRequest => {
  return {
    dosis: response.dosis,
    id: response.id,
    productoDescripcion: response.productoDescripcion,
    productoId: response.productoId,
  };
};
